import styled from 'styled-components';
import { Box, spacing, Text } from '@landr/maestro';

const BylineSkeleton = styled(Box)`
    height: ${spacing('lg')};
`;

export const FirstBylineSkeletonWrapper = styled(BylineSkeleton)`
    width: 60%;
    min-width: 300px;
    margin-top: ${spacing('lg')};
    margin-bottom: ${spacing('sm')};
`;

export const SecondBylineSkeletonWrapper = styled(BylineSkeleton)`
    width: 30%;
    min-width: 100px;
    margin-bottom: ${spacing('xs')};
`;

export const Byline = styled(Text)`
    display: block;
    margin-top: ${spacing(3)};
`;
